const uri = encodeURIComponent(process.env.VUE_APP_WECHAT_AUTHURL);
export const weChatAuth = () => {
  const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx47505e13d7226a0f&redirect_uri=${uri}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
  window.location.href = authUrl;
};
